<template>

  <div class="container-fluid container-temperature">
    <div class="tab-header" v-if="warehouses">
      <form action="" class="d-flex flex-column justify-content-center" @submit.prevent="getResult">
        <div class="col-12 d-flex align-items-center ">
          <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="filter-wr-name" class="form-label">საწყობი</label>
            <v-select v-model="warehouse" label="name" id="filter-wr-name"
                       :options="warehouses.list"
                      placeholder="აირჩიეთ საწყობი"
                      @option:selected="onChangeWarehouse"
                      :class="v$.warehouse.$error ? 'red' : ''"
            >
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>

          </div>

          <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="room-name" class="form-label">ოთახი</label>
            <v-select v-model="selectedRoom"  label="name" id="room-name" :options="rooms"
                       :disabled="rooms.length === 0"
                      placeholder="აირჩიეთ ოთახი"
                      @option:selected="onChangeRooms"
                      :class="v$.selectedRoom.$error ? 'red' : ''"
            >
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>
          </div>

          <div class="col-md-2 col-sm-4 form-group mb-3">
            <label for="sensor-name" class="form-label">სენსორი</label>
            <v-select v-model="sensor" label="name" id="sensor-name" :options="sensors"
                      placeholder="აირჩიეთ სენსორი"
                      :disabled="sensors.length === 0"
                      :class="v$.sensor.$error ? 'red' : ''"
            >
              <template v-slot:option="sensor">
                {{sensor.name}}  {{sensor.description !== null && sensor.description !== "" && typeof sensor.description !== "undefined" ? `- ${sensor.description} ` : '' }}
              </template>
              <template v-slot:no-options>სია ცარიელია</template>
            </v-select>
          </div>

          <div class="form-group mb-3 dropdown-height">
            <label for="period-name" class="form-label">პერიოდი</label>
            <DateRangePicker element-id="alert-daterange" date-range-value="dateRangeValue" />
          </div>



          <div class="col-md-2 col-sm-4 form-group  button-groups d-flex">
            <button type="button" class="btn btn-filter" @click="showTemperatureFilter">
              <img src="/svgs/filter2.svg" alt="">
            </button>
            <button type="submit" class="btn btn-primary">
              გენერირება
            </button>
						<button type="button" class="btn btn-primary" @click="exportExcel">
							Excel
						</button>
          </div>


        </div>

        <transition name="fade" mode="out-in">
          <div class="col-md-12 row addiotional-filter" v-if="isShowingExtraFilter">

            <div class="col-md-2 col-sm-4 no-p-r timerange-col">
              <div class="input-group addon-filter">
              <span class="input-group-text no-padding" id="basic-addon2">
                დროის მონაკვეთი
              </span>
                <v-select v-model="timeRangeStart" class="addon-select" label="name"
                          id="interval-name" :options="timeArray" value="00:00">
                  <template v-slot:no-options>სია ცარიელია</template>
                </v-select>
                <span class="input-group-text no-padding" id="eye-addon">
                  <img :src="'/svgs/clock.svg'" >
                </span>
                <v-select v-model="timeRangeEnd" class="addon-select second-addon-select"
                          label="name" id="interval-name" :options="timeArray" value="24:00">
                  <template v-slot:no-options>სია ცარიელია</template>
                </v-select>
              </div>
            </div>



            <div class="col-lg-3 col-sm-6 week-col">
              <div class="input-group week-groups">
                <span :class="'input-group-text ' + isSelectedWeek(1)" id="basic-addon3" @click="selectWeek(1)">
                  ორ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(2)" @click="selectWeek(2)" id="basic-addon4">
                  სმ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(3)" @click="selectWeek(3)" id="basic-addon5">
                  ოთხ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(4)" @click="selectWeek(4)" id="basic-addon6">
                  ხთ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(5)" @click="selectWeek(5)" id="basic-addong7">
                  პრ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(6)" @click="selectWeek(6)" id="basic-addon8">
                  შბ
                </span>
                <span :class="'input-group-text ' + isSelectedWeek(7)" @click="selectWeek(7)" id="basic-addon9">
                  კვ
                </span>
              </div>
            </div>
          </div>
        </transition>

      </form>
    </div>

    <div class="col-12 tab-content">


      <transition name="fade" mode="out-in">

        <table class="table" v-if="!this.loading && resultData && resultData.list.data">
          <thead>
          <tr>
            <th @click.prevent="sortBy('alert.name','alert')">
              სახელი
              <template v-if="isFilteredBy('alert.name')">
                <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
              </template>
            </th>
            <th @click.prevent="sortBy('value1')">
              განგაში
              <template v-if="isFilteredBy('value1')">
                <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
              </template>
            </th>
            <th @click.prevent="sortBy('datestamp')">
              თარიღი
              <template v-if="isFilteredBy('datestamp')">
                <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="result in resultData.list.data" v-bind:key="result">
            <td>{{ result.alert.name }}</td>
            <td>{{ getAlertDescription(result) }} </td>
            <td>{{ result.datestamp }} </td>
          </tr>
          </tbody>
        </table>
      </transition>
      <transition name="fade" mode="out-in">
        <LoaderItem custom-classes="splash-screen-child" v-if="this.loading"></LoaderItem>
      </transition>
    </div>

    <template v-if="this.last_page > 1">
      <v-pagination
          v-model="this.page"
          :pages="this.last_page"
          :range-size="1"
          active-color="#DCEDFF"
          @update:modelValue="paginationHandler"
      />
    </template>

  </div>

</template>

<script>

import {ref} from "vue";
import DateRangePicker from "@/components/partials/reusable/DateRangePicker";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import LoaderItem from "@/components/partials/LoaderItem";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
  name:'AlertReport',
  components:{DateRangePicker, LoaderItem, VPagination},
  computed:{
    resultData(){
      return this.$store.state.reports.alerts.data
    },
    warehouses(){
      return this.$store.state.warehouse.list.data
    },
    rooms(){
      if (this.$store.state.warehouse.rooms.data){
        return this.$store.state.warehouse.rooms.data.list
      }
      return []
    },
    sensors(){
      if (this.$store.state.warehouse.sensors.sensors){
        return this.$store.state.warehouse.sensors.sensors
      }
      return []
    }
  },
  methods:{
    isFilteredBy(key){
      if (this.filteringState.key === key){
        return true
      }
      return false
    },
    sortBy(key, nested = false){
      this.changeFilterState(key)

      let splitedKey = key.split('.')[key.split('.').length - 1]

      this.resultData.list.data.sort((a,b)=>{
        let comparableA = a[splitedKey]
        let comparableB = b[splitedKey]

        if (nested){
          let path = nested.split('.')
          let tmpObj  = null
          let tmpObjB = null
          for (let i = 0 ; i < path.length; i++){
            if (i === 0){
              tmpObj = a[path[0]]
              tmpObjB = b[path[0]]
              continue
            }
            tmpObj = tmpObj[path[i]]
            tmpObjB = tmpObjB[path[i]]

          }
          if (tmpObj && tmpObjB){
            comparableA = tmpObj[splitedKey]
            comparableB = tmpObjB[splitedKey]
          }
        }

        if (this.filteringState.ordering === 'DESC'){
          return  comparableA > comparableB ? 1 : -1
        }else{
          return  comparableA < comparableB ? 1 : -1
        }
      })
    },
    changeFilterState(key){
      if (this.filteringState.key === key){
        this.filteringState.ordering = this.filteringState.ordering ===  'ASC' ? 'DESC' : 'ASC'
        return
      }
      this.filteringState.key = key
      this.filteringState.ordering = 'DESC'
    },
    getIconByOrdering(){
      let icon = 'sort-down'
      if (this.filteringState.ordering === 'DESC'){
        icon = 'sort-up'
      }
      return icon
    },
    paginationHandler(page){
      this.currentPage = page
      this.getResult()
    },
    getAlertDescription(alert){
      let tempType = alert.value1 === "1" ? "ასცდა " : "ჩამოსცდა "
      return `${tempType} ლიმიტს : ${alert.value2} დაფიქსირდა:  ${alert.value3}`
    },
    showTemperatureFilter(){
      this.isShowingExtraFilter = !this.isShowingExtraFilter
    },
    onChangeWarehouse(element){
      this.$store.dispatch('warehouse/getWarehouseRooms', element.id).then(
          () => {
            this.sensor = null
            if (this.rooms.length > 0){
              this.onChangeRooms(this.rooms[0])
            }else{
              this.selectedRoom = null
              this.$store.state.warehouse.sensors = []
              this.sensor = null
            }
          }
      )
    },
    onChangeRooms(element){
      this.$store.dispatch('warehouse/getWarehouseRoomSensors', element.id).then(
          () => {
            if (!this.sensor){
              this.selectedRoom = this.rooms[0]
            }
            this.sensor = this.sensors[0]
          }
      )
    },
    selectWeek(week){
      this.weeksArray[week] ? delete this.weeksArray[week] : this.weeksArray[week] = week
    },
    isSelectedWeek(weekIndex){
      return this.weeksArray[weekIndex] ? 'active-week' : '';
    },
		async exportExcel(){
			const result = await this.v$.$validate()
			if (!result) {
				// notify user form is invalid
				return 0
			}else{
				this.loading = true
				let filterData = {
					weekdays: this.weeksArray.join(','),
					dateRange: document.getElementById('alert-daterange').value.replace(/\./g,'/'),
					sensorimei: this.sensor.imei,
					sensorindex: this.sensor.index,
					warehouseid: this.warehouse.id,
					room_id: this.selectedRoom.id,
					timeRangeStart: this.timeRangeStart,
					timeRangeEnd: this.timeRangeEnd,
					page: this.currentPage,
					perPage: this.perPage,
				}
				this.$store.dispatch('reports/getTemperatureAlertReportsExport', filterData).then(
						()  => {
							this.loading = false
							this.last_page = this.resultData.list.last_page
							this.page = this.resultData.list.current_page
						}
				)
			}

		},
    async getResult(){
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return 0
      }else{
        this.loading = true
        let filterData = {
          weekdays: this.weeksArray.join(','),
          dateRange: document.getElementById('alert-daterange').value.replace(/\./g,'/'),
          sensorimei: this.sensor.imei,
          sensorindex: this.sensor.index,
          warehouseid: this.warehouse.id,
          room_id: this.selectedRoom.id,
          timeRangeStart: this.timeRangeStart,
          timeRangeEnd: this.timeRangeEnd,
          page: this.currentPage,
          perPage: this.perPage,
        }
        this.$store.dispatch('reports/getTemperatureAlertReports', filterData).then(
            ()  => {
              this.loading = false
              this.last_page = this.resultData.list.last_page
              this.page = this.resultData.list.current_page
            }
        )
      }

    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    const timeArray = [
      '00:00', '01:00', '02:00', '03:00',
      '04:00', '05:00', '06:00', '07:00',
      '08:00', '09:00', '10:00', '11:00',
      '12:00', '13:00', '14:00', '15:00',
      '16:00', '17:00', '18:00', '19:00',
      '20:00', '21:00', '22:00', '23:00',
      '24:00',
    ]

    const room = ref('')
    return {
      timeArray,
      isShowingExtraFilter:false,
      room,
      warehouse: ref(null),
      selectedRoom: ref(null),
      sensor: ref(null),
      interval: ref(null),
      timeRangeStart: ref('00:00'),
      timeRangeEnd: ref('24:00'),
      dateRangeValue: ref(null),
      loading: false,
      weeksArray:['',1,2,3,4,5,6,7],
      currentPage: ref(1),
      perPage: ref(50),
      last_page: ref(0),
      page: ref(1),
      filteringState: ref({
        ordering: 'DESC',
        key: null
      })
    }
  },
  mounted() {
    this.$store.dispatch('warehouse/getWarehouseList').then(
        () => {
          this.loading = false
          this.warehouse = this.warehouses.list[0]
          this.onChangeWarehouse(this.warehouse)
        }
    )
  },
  validations () {
    return {
      warehouse: { required },
      selectedRoom: { required },
      sensor: { required },
    }
  }
}
</script>

<style scoped>



.container-temperature{
  padding-left: 0;
  padding-right: 0;
}

.tab-header{
  padding:15px
}

.form-group:not(:first-child){
  margin-left: 10px;
}





.no-padding{
  padding: 5px;
}


.vs__dropdown-toggle{
  height: 100% !important;
  border: 1px solid var(--dropzone-border) !important;
  min-width: 100px;
}

.vs__search{
  display: block !important;
  padding: .11rem 0 !important;
}


.addon-select > .vs__dropdown-toggle{
  border: 1px solid var(--dropzone-border);
  border-left: 0 !important;
  border-radius: 0;
  border-right: 0;
}

 .second-addon-select > .vs__dropdown-toggle{
   border-left: 0 !important;
   border-right: 1px solid var(--dropzone-border);
   border-top-right-radius: 5px !important;
   border-bottom-right-radius: 5px !important;
 }

 .form-control{
   border: 1px solid var(--dropzone-border);
 }

 .red{
   border-radius: 5px;
   border: 1px solid red !important;
 }

.splash-screen-child{
  position: relative !important;
  padding-top: 5% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}

.input-group-text.active-week{
  background: var(--submit-button-bg) !important;
  color: #ffffff !important;
}

.table{
  color:var(--second-titles);
  font-family: "TBCDinNusxuri-Medium";
  font-size: 16px;
}
.table > :not(:first-child){
  border: 1px solid var(--border-color) !important;
}
.table tbody tr:last-child{
  border: transparent;
}
.table tbody tr:hover{
  background: var(--hover-item);
  cursor: pointer;
}

.table > thead{
  vertical-align: middle;
  color: var(--text-sub-bold-color);
}

.table > :not(:first-child){
  border-top: 1px solid var(--border-color);
}

.table td:first-child, table th:first-child{
  padding-left: 20px;
}

.no-padding-div{
  padding-left: 5px;
  padding-right: 5px;
}



</style>